if(typeof FN == 'undefined') FN = {};


FN.supportConfig = {
  selectors: {
    helpCenterSearchForm: '.search-container form'
  }
}




FN.helpCenter = {
  init: function() {
    if($('#page--support__help-center').length != 1) return;
    FN.helpCenter.addFormAction();
  },

  addFormAction: function() {
    var formAction = false;
    if(FN.helpers.platform() === 'mac'){
      formAction = FN.config.urls.helpSearchMac;
    }else{
      formAction = FN.config.urls.helpSearchWindows;
    }
    $(FN.supportConfig.selectors.helpCenterSearchForm).attr('action', formAction);
  }
};




$(document).ready(function(){
  FN.helpCenter.init();
});
